export default __webpack_public_path__ + "static/media/plantation_delivery_c.7fe92710.mp4";